module.exports = __webpack_public_path__ + "img/c-class-coupe.3672a65a.jpg";